// will be eventually replaced by ES8 -> export default from './filename';
// see: https://github.com/leebyron/ecmascript-export-default-from
import Checkbox from './checkbox';
export default Checkbox;
